import axios from 'axios';
import { endpoints } from 'utils/global-constants';

/**
 * Add upsells to cart
 * @param {object} requestPayload
 * @returns
 */
export const addUpsellItemToCart = async (requestPayload) => {
  try {
    const response = await axios.post(endpoints.addUpsellItemToCart, requestPayload);
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};
